<template>
  <div>
    <div>
      <div>
        <v-img
          class="mx-auto"
          width="150px"
          src="https://www.sinthanee.com/image/cache/11%20it/D413IA-EB303TS-1000x1000.png"
        ></v-img>
      </div>
      <div class="px-5">
        <v-layout row wrap class="ma-0">
          <v-flex xs6 v-for="(item, k) in items" :key="k">
            <div>
              {{ item }}
            </div>
            <div>-</div>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        'ID',
        'Title',
        'Category',
        'Description',
        'ShortDescription',
        'Image link',
        'Link',
        'Price',
        'Sale price',
        'Sale price effective date',
        'Availability',
        'Product type',
        'Brand',
        'Condition ',
        'Adult',
        'Color',
        'Gender',
        'Size',
        'Weight',
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/ticket2/productandbranch/ProductDetail.vue